import React from 'react';
import SlackLogo from '../img/slack.png';

function SlackIcon({ onClick }) {
  return (
    <button onClick={onClick} className='SlackIcon'>
      <img src={SlackLogo} alt="Slack logo" width="50" height="50" />
    </button>
  );
}

export default SlackIcon;